<template>
  <v-card color="grey lighten-4" flat>


    <v-flex xs12 sm12>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title class="white--text">{{$t('Seller-Information')}}</v-toolbar-title>
        <v-spacer></v-spacer>

          <v-btn class="white--text" @click="goDetail(Satici)" flat> <span class="hidden-sm-and-down"> {{ $t('Update') }} </span>
            <v-icon right dark>create</v-icon>
          </v-btn>
      </v-toolbar>
    </v-flex>

    <v-container fluid>
      <v-layout row wrap>


        <v-flex pa-1 xs12 sm12 md6>
          <v-flex xs12 sm12 md12 pa-1>
            <v-card flat="" class="black--text">
              <v-layout>
                <v-flex xs2 sm2 md1>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="black" large="">perm_identity</v-icon>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm10 md11>

                  <v-card-title primary-title="">

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                          <v-list-tile-title>
                            <span class="subtitle-1
 font-weight-">
                              {{$t('Title_label')}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md10>
                          <v-list-tile-title>
                            <span class="subtitle-1
 font-weight-">
                              : {{ Satici.Isim }}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                       <v-divider></v-divider>
                    </v-flex>


                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                          <v-list-tile-title>
                            <span class="subtitle-1
 font-weight-">
                              {{this.$t('Code')}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md10>
                          <v-list-tile-title>
                            <span class="subtitle-1
 font-weight-">
                              : {{Satici.Kod}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                       <v-divider></v-divider>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                          <v-list-tile-title>
                            <span class="subtitle-1 font-weight-">
                              <div class="font-weight- subtitle-1  black--text  mb-1">{{$t('Authorized_label')}}</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md10>
                          <v-list-tile-title>
                            <span class="subtitle-1 font-weight-">
                              <div class="font-weight- subtitle-1  black--text  mb-1">:
                                {{Satici.Yetkili}} </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                       <v-divider></v-divider>
                    </v-flex>


                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                          <v-list-tile-title>
                            <span class="subtitle-1 font-weight-">
                              <div class="font-weight- subtitle-1  black--text  mb-1">{{$t('Taxcenter_label')}}</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md10>
                          <v-list-tile-title>
                            <span class="subtitle-1 font-weight-">
                              <div class="font-weight- subtitle-1 black--text  mb-1">:
                                {{Satici.VDaire}} </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                       <v-divider></v-divider>
                    </v-flex>


                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                          <v-list-tile-title>
                            <span class="subtitle-1 font-weight-">
                              <div class="font-weight- subtitle-1  black--text  mb-1">{{$t('Taxnumber_label')}}</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md10>
                          <v-list-tile-title>
                            <span class="subtitle-1 font-weight-">
                              <div class="font-weight- subtitle-1  black--text  mb-1">:
                                {{Satici.VNo}} </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>


                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <span class="headline-1 font-weight-">{{ $t('General-Information') }}</span>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-flex>


        <v-flex pa-1 xs12 sm12 md6>
          <v-flex xs12 sm12 md12 pa-1>
            <v-card flat  class="black--text">
              <v-layout>
                <v-flex xs2 sm2 md1>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="black" large="">where_to_vote</v-icon>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm10 md11>

                  <v-card-title primary-title="">

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md1>
                          <v-list-tile-title>
                            <span class="subtitle-1  black--text font-weight-">
                              Tel 1
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md11>
                          <v-list-tile-title>
                            <span class="subtitle-1  black--text font-weight-">
                              : {{ Satici.Tel1 }}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                       <v-divider></v-divider>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md1>
                          <v-list-tile-title>
                            <span class="subtitle-1 black--text font-weight-">
                              Tel 2
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md11>
                          <v-list-tile-title>
                            <span class="subtitle-1 black--text font-weight-">
                              : {{Satici.Tel2}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                       <v-divider></v-divider>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md1>
                          <v-list-tile-title>
                            <span class="subtitle-1  font-weight-">
                              <div class="font-weight- subtitle-1 black--text     mb-1">Web</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md11>
                          <v-list-tile-title>
                            <span class="subtitle-1  font-weight-">
                              <div class="font-weight- subtitle-1 black--text    mb-1">:
                                {{Satici.Web}} </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                       <v-divider></v-divider>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md1>
                          <v-list-tile-title>
                            <span class="subtitle-1  font-weight-">
                              <div class="font-weight- subtitle-1  black--text   mb-1">{{ $t('Address_label') }}</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md11>
                          <v-list-tile-title>
                            <span class="subtitle-1  font-weight-">
                              <div class="font-weight- subtitle-1  black--text   mb-1">:
                                {{Satici.Adres}} </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                       <v-divider></v-divider>
                    </v-flex>


                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md1>
                          <v-list-tile-title>
                            <span class="subtitle-1 black--text  font-weight-">
                              <div class="font-weight- subtitle-1 black--text   mb-1">{{ $t('City') }}</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md11>
                          <v-list-tile-title>
                            <span class="subtitle-1  font-weight-">
                              <div class="font-weight- subtitle-1 black--text  mb-1">: {{Satici.Sehir}}</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                {{ $t('Contact-Information') }}
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-flex>


      </v-layout>
    </v-container>

  </v-card>




</template>


<script>
  import auth from '../../../../api/auth'
  import tarihim from "@/components/app/customcomp/tarihim.vue"
  import helpers from "@/components/app/customcomp/helpers.js"
  import tool from "../../coper/tools";


  export default {
    data() {
      return {
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        modal2: false,
        dateFormatted2: '',

        Satici: {
          SaticiTipi: null,
          Ref: null,
          SirketNo: null,
          Kod: null,
          Isim: null,
          Cari_Kod: {
            id: null,
            kod: null,
            isim: null
          },
          Adres: null,
          PK: null,
          Ulke: null,
          Sehir: null,
          Yer: null,
          SaticiKonumu: null,
          Yetkili: null,
          Web: null,
          HavaAlani: null,
          VDaire: null,
          VNo: null,
          Tel1: null,
          Tel2: null,
          Fax: null,
          Teleks: null,
          Email: null,
          GSM: null,
          Ic_Dis: null,
          Aciklamalar: null,
          LocationF: null,
          OdaTanimlari: null,
          OtelOzellikleri: null,
          krdDerece: null,
          krdDakika: null,
          krdSaniye: null,
          krdDereceM: null,
          krdDakikaM: null,
          krdSaniyeM: null,
          Grup: null,
          PasifKayit: null,
          GlobalKod: null,
          ZincirKodu: null,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          AutoCreate: null,
        },



        Current: {
          CompanyCode: '',
          Code: '',
          Title: '',
          Phone1: '',
          Phone2: '',
          Mobile: '',
          Web: '',
          Authorized: '',
          WarningNote: '',
          InfoNote: '',
          Invoice: {
            Address: '',
            PostCode: '',
            Province: '',
            Country: '',
            TaxNumber: '',
            TaxOffice: '',
            IdentityNumber: ''
          }
        },
        StartDate: null,
        EndDate: null,
        Faturaedilmemisbilet: 0,
        Toplamfatbiletad: 0,
        Toplambiletadet: 0,
        load: false,
        load1: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',

        dictionary: {
          custom: {

            tarihsecbas: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsecbit: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },

      }
    },
    methods: {
      goDetail(val){
        const url = '#/coper/saticilar/islem/id?isl=get&kod='+ escape(val.Kod) +'&tip='+ val.SaticiTipi;
        window.open(url,"_self");
      },
      Raporla: Raporla,
    },
    beforeMount: beforeMount,
    components: {
      tarihim
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
  }




  function beforeMount() {

    this.load = true
    this.load1 = false

    if (this.$route.query.kod != null && this.$route.query.kod != '' && this.$route.query.tip != null && this.$route
      .query.tip != '') {

      var prm = {
        saticiKodu: unescape(this.$route.query.kod),
        saticiTipi: this.$route.query.tip
      }

      tool.http_post(this, "SaticiList", prm).then(
        response => {

          if (response.body.Status == true) {

            this.load = false
            this.load1 = true

            if (response.body.SaticiList.length > 0) {
              this.Satici = response.body.SaticiList[0]

            } else {

            }


          } else {
            this.load = false
            this.load1 = true
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        },
        response => {
          this.load = false
          this.load1 = true
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      );

    } else {
      this.text1 = 'Hatalı link, sayfa kapatılıyor.'
      this.snackbar = true

      setTimeout(function () {
        window.close();
      }.bind(this), 4000)
    }

  }



  function Raporla() {

    this.load1 = false

    this.$validator.validateAll().then((result) => {

      if (result) {

        var bastarih = new Date(this.date)
        var bittarih = new Date(this.date2)

        if (bastarih <= bittarih) {

          var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));



          var params = {
            SirketKodu: credentials1.SirketKodu,
            BaslangicTarihi: new Date(this.date),
            BitisTarihi: new Date(this.date2),
            CariKod: this.Current.Code
          }

          this.$http.post(auth.API_URL + 'api/TicketReport/SummaryInfoList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.load1 = true

            this.Toplambiletadet = response.body.SatisAdet
            this.Faturaedilmemisbilet = response.body.FaturalanmamisBiletAdet
            this.Toplamfatbiletad = response.body.FaturalanmisBiletAdet

          }, (response) => {
            this.load1 = true

            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.load1 = true

              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        } else {
          this.load1 = true

          this.text1 = this.$t('start-date-cannot-greater-than-end-date')
          this.snackbar = true
        }
      }
    })
  }
</script>

<style>

</style>